export function maskEmail(email: string): string {
  if (!email || !email.includes('@')) return '***';
  const [local, domain] = email.split('@');
  const maskedLocal = local.charAt(0) + '***';
  const domainParts = domain.split('.');
  const maskedDomain = domainParts[0].charAt(0) + '****.' + domainParts.slice(1).join('.');
  return `${maskedLocal}@${maskedDomain}`;
}

export function maskPhone(phone: string): string {
  if (!phone || phone.length < 4) return '***';
  const last4 = phone.slice(-4);
  const prefix = phone.slice(0, phone.length - 4).replace(/\d/g, '*');
  return prefix + last4;
}
